module.exports = __webpack_public_path__ + "img/register-image.f533eac8.png";